import * as Yup from 'yup';
import { getRequiredText } from '../../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { InstitutionAddRequestMailingAddressValidationSchema, InstitutionAddRequestPhysicalAddressValidationSchema } from '../../../../global/validation-schemas/address-form-validation';
import { InstitutionAddRequestPhoneValidationSchema } from '../../../../global/validation-schemas/phone-number-form-validation';
import { Other } from '../../../clergy-bio/education/clergy-bio-education-item';
import { InstitutionProps } from '../../models/arc-epi-props';
import { GetBusinessEmailAddressValidationSchema, GetKnownAsValidationSchema, GetWebsiteUrlValidationSchema } from './institution-model';

export const displayQuestionOptions = [
	'Bookstore',
	'COO',
	'Campus Ministry',
	'Cemetery',
	'Chaplaincy',
	'College',
	'Counseling Center',
	'Daycare',
	'ECCC',
	'Health Agency',
	'Hospice',
	'Hospital',
	'Mentoring Program',
	'Ministry',
	'National Organization',
	'Nursery',
	'Nursing Home',
	'Other',
	'Preschool',
	'Prison Ministry',
	'Retirement Home',
	'School',
	'Seminary',
	'Special Needs Ministry',
	'University',
];

export interface InstitutionAddRequest {
	legal_name: string;
	common_name: string;
	institution_type: string;
	institution_type_other: string;
	tec_org: string;
	year_established: string;
	reason: string;
	relationship_start_date: string;
	mail_address1: string;
	mail_address2: string;
	mail_address3: string;
	mail_city: string;
	mail_state: string;
	mail_postal_code: string;
	mail_country: string;
	street_address1: string;
	street_address2: string;
	street_address3: string;
	street_city: string;
	street_state: string;
	street_postal_code: string;
	street_country: string;
	office_country_code: string;
	office_phone: string;
	office_ext: string;
	office_phone_formatted: string;
	office_phone_number: string;
	office_phone_area_code: string;
	fax_country_code: string;
	fax_phone_area_code: string;
	fax_phone_formatted: string;
	fax_phone_number: string;
	website: string;
	email: string;
	dio: string;
}

export function GetInstitutionAddRequestValidationSchema(labelSettings: LabelSettingProps, institutionSettings: InstitutionProps, dioRequired: boolean){

	return Yup.lazy(({
		office_phone_formatted,
		office_country_code,
		fax_formatted,
		fax_country_code }) => {            
            const validationSchema = Yup.object().shape({
                common_name: GetKnownAsValidationSchema(labelSettings),
                legal_name: Yup.string().required(getRequiredText(labelSettings.requiredFormat, labelSettings.institutionLegalName)),
                institution_type: Yup.string().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.institutionTypeLabel)),
                year_established: Yup.string().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.yearEstablishedLabel)),
                relationship_start_date: Yup.date().nullable().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.institutionAddRequestRelationshipStartDateLabel)),
                institution_type_other: Yup.string().when(['institution_type'], {
                    is: (a) => a === Other,
                    then: Yup.string().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.institutionTypeOtherLabel)),
                }),
                tec_org: Yup.string().when(['institution_type'], {
					is: (a) => displayQuestionOptions.includes(a),
                    then: Yup.string().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.isTecLabel)),
                }),
                ...InstitutionAddRequestMailingAddressValidationSchema(labelSettings),
                ...InstitutionAddRequestPhysicalAddressValidationSchema(labelSettings),
                ...InstitutionAddRequestPhoneValidationSchema(labelSettings,
                    office_phone_formatted,
                    office_country_code,
                    fax_formatted,
                    fax_country_code),
                email: GetBusinessEmailAddressValidationSchema(labelSettings),
                website: GetWebsiteUrlValidationSchema(labelSettings),
                dio: dioRequired ? Yup.string().required(getRequiredText(labelSettings.requiredFormat, institutionSettings.dioceseLabel)) : null,
            });
            
            return validationSchema;
    });
}

